import { SET_SITE_DATA, SET_PAGE, SET_HOMEPAGE_DATA, SET_USER_DATA, SET_LOADING, SET_CART_DATA, SET_COUPON_DATA, SET_SEARCH_TEXT } from "./Action";

const initialState = {
    siteData: {},
    userData: {},
    page: "",
    isLoading: true,
    homePage: {},
    cartData: [],
    couponData: null,
    searchText: ""

};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case SET_SITE_DATA:
            return { ...state, siteData: payload };
        case SET_PAGE:
            return { ...state, page: payload };
        case SET_HOMEPAGE_DATA:
            return { ...state, homePage: payload };
        case SET_USER_DATA:
            return { ...state, userData: payload };
        case SET_LOADING:
            return { ...state, isLoading: payload };
        case SET_CART_DATA:
            return { ...state, cartData: payload };
        case SET_COUPON_DATA:
            return { ...state, couponData: payload };
        case SET_SEARCH_TEXT:
            return { ...state, searchText: payload };
        default:
            return state;
    }
}


export default reducer